import { makeAutoObservable } from "mobx";
import { ICalculatorFeeDto, ICalculatorItemBalanceDto, ICalculatorShippingCostDto, REFUND_METHODS } from "../components/refund-calculator-drawer/refund-calculator-types";
import { IMoneyDto } from "../rma-types";


class RefundCalculatorLineStore {

    private _changes: ICalculatorItemBalanceDto & ICalculatorShippingCostDto & ICalculatorFeeDto = {} as ICalculatorItemBalanceDto & ICalculatorShippingCostDto & ICalculatorFeeDto;
    private _model: ICalculatorItemBalanceDto & ICalculatorShippingCostDto & ICalculatorFeeDto;
    private _paymentCurrencyCode: string; 

    constructor(
        line: ICalculatorItemBalanceDto & ICalculatorShippingCostDto & ICalculatorFeeDto, 
        paymentCurrencyCode: string,
        private _getProductName?: (v: number) => string
    ) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._paymentCurrencyCode = paymentCurrencyCode;
        this._model = line;
    }

    public get isRejected(): boolean {
        return this._model.is_rejected ?? false;
    }

    public get isSelected(): boolean { return this._changes.is_selected ?? this._model.is_selected; }
    public get productCaseId(): number { return this._model.product_case_id; }

    private _findPaymentCurrencyMoneyDto(dtoList: IMoneyDto[]) {
        const dto = dtoList.find(amount => amount.currency_code === this._paymentCurrencyCode);
        if (!dto) {
            throw new Error(`amount not found for payment currency ${this._paymentCurrencyCode}`); 
        }
        return dto;
    }
    
    public get taxDtoInPaymentCurrency(): IMoneyDto | undefined { 
        const taxAmount = this._findPaymentCurrencyMoneyDto(this._model.tax);
        return taxAmount; 
    }

    public get amountDtoInPaymentCurrency(): IMoneyDto | undefined {
        const amount = this._findPaymentCurrencyMoneyDto(this._model.amount);
        return amount;
    }

    public get amount(): number { 
        const amount = this._findPaymentCurrencyMoneyDto(this._model.amount);
        return amount.amount;
    }

    public get tax(): number { 
        const tax = this._findPaymentCurrencyMoneyDto(this._model.tax);
        return tax.amount;
    }

    public get title(): string { 
        if (this._model.order_name) {
            return `Order ${this._model.order_name}`;
        }
        if (this._model.rma_id) {
            return `RMA${this._model.rma_id}`;
        } 
        if (this._model.product_case_id) {
            return `${this._getProductName? this._getProductName(this._model.product_case_id) :""}`; 
        }
        return ''; 
    } 

    
    public setIsSelected(value: boolean) {
        if(!this.isSelected && this.isRejected) {
            return;
        }
        this._changes.is_selected = value;
    }

    public getUpdatedState() {
        return {...this._model, ...this._changes};
    }

    public getAvailableAmountSubtotal(refundMethodType: REFUND_METHODS) {
        const availableAmount = this._model.available_virtual_amount?.find(amount => amount.refund_method_id === refundMethodType);
        const availableAmountInPaymentCurrency = availableAmount?.amount.find(amount => amount.currency_code === this._paymentCurrencyCode);
        return availableAmountInPaymentCurrency?.amount?? 0;
    }

}

export default RefundCalculatorLineStore;
